<template>
  <div class="takePhotoDiv">
    <div class="takePhoto">
      <img src="../../assets/image/btn_heying_nor.png" alt="背景" class="takePhotoImg" />
      <div class="photoUpDiv">
        <img @click="photoShow = true" src="../../assets/image/btn_zhaopian_nor.png" alt="照片1" class="photoUpImg"
          v-if="photoAndBless.imgUrl == null" />
        <img :src="photoAndBless.imgUrl" alt="照片" class="photoUpImg" v-else />
      </div>
      <div class="blessingDiv" v-if="photoAndBless === null">
        {{ this.$route.query.blessing }}
      </div>
      <div class="blessingDiv" v-else>
        {{ photoAndBless.msg }}
      </div>
      <div class="name">——{{ photoAndBless.nickname }}</div>
      <van-action-sheet v-model="photoShow" @select="onSelect" description="更换头像" cancel-text="取消">
        <van-uploader :before-read="beforeRead" :after-read="afterRead">
          <div class="selectPhoto">从相册选择</div>
        </van-uploader>
      </van-action-sheet>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      photoShow: false,
      openId: localStorage.getItem("siginOpenid"),
      photoAndBless: ''
    };
  },
  created() {
    this.getPhotoAndBless();
  },
  methods: {
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.photoShow = false;
      console.log(item.name);
    },
    // 返回布尔值
    // 先判断上传文件类型
    beforeRead(file) {
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.$toast("请上传 jpg,png 格式图片");
        return false;
      }
      return true;
      /* return new Promise((resolve, reject) => {
        console.log("压缩前", file); // 压缩到400KB,大于400KB的图片都会进行压缩，小于则不会
        imageConversion.compressAccurately(file, 400).then((res) => {
          // console.log(res)
          res = new File([res], file.name, {
            type: res.type,
            lastModified: Date.now(),
          });
          console.log("压缩后", res);
          resolve(res);
        });
      }); */
    },
    /* onOversize(file) {
      console.log(file);
      this.$toast("文件大小不能超过 500kb");
    }, */
    async afterRead(file) {
      // 此时可以将文件上传至服务器
      console.log(file);
      let param = new window.FormData();
      param.append("file", file.file);
      param.append("openId", this.openId);
      param.append("msg", this.$route.query.blessing);
      const result = await this.$http.post("/wx/enterbless", param);
      if (result.data.code == "101") {
        this.$toast("上传成功");
        location.reload();
      } else {
        this.$toast(result.data.msg);
      }
    },
    async getPhotoAndBless() {
      const result = await this.$http.get(
        "/wx/getMsgById",
        {
          params: { openId: this.openId },
        }
      );
      this.photoAndBless = result.data.list;
    }
  },
};
</script>
<style lang="less" scoped>
.takePhotoDiv {
  position: relative;
  min-height: 100vh;
  width: 100%;

  .takePhotoImg {
    height: 100%;
    width: 100%;
  }

  /* background-image: url(../../assets/image/btn_heying_nor.png);
  background-size: 100%, 100%;
  background-repeat: no-repeat, no-repeat; */
  .photoUpDiv {
    position: absolute;
    left: 50%;
    top: 19%;
    transform: translateX(-50%);
    width: 46%;
    height: 60vw;

    .photoUpImg {
      height: 100%;
      width: 100%;
      border-radius: 15px;
    }
  }

  .blessingDiv {
    position: absolute;
    top: 54%;
    left: 15%;
    width: 70%;
    font-weight: 400;
    color: #666666;
    line-height: 1.5rem;
    word-wrap: break-word;
    word-break: break-all;
  }

  .name {
    position: absolute;
    top: 62%;
    right: 10%;
    font-weight: 400;
    color: #666666;
  }
}

.selectPhoto {
  text-align: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #00706E;
  margin: 20px 0;
}

.van-uploader {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/siginIn/TakePhoto.vue